import { render } from "./BaseNode.vue?vue&type=template&id=0ede2e64&scoped=true&lang=pug"
import script from "./BaseNode.vue?vue&type=script&lang=js"
export * from "./BaseNode.vue?vue&type=script&lang=js"

import "./BaseNode.vue?vue&type=style&index=0&id=0ede2e64&lang=scss&scoped=true"
import "./BaseNode.vue?vue&type=style&index=1&id=0ede2e64&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ede2e64"]])

export default __exports__